// extracted by mini-css-extract-plugin
export default {"exitButton":"SharedToolTip_exitButton__p4vvR","header":"SharedToolTip_header__Dt3NB","bodyContent":"SharedToolTip_bodyContent__hKOdx"};